// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* 본문 섹션 */
  .history-section {
      padding: 60px;
  }

  /* 2026.02.12 class 변경 */
  .history-container {
      display: flex;
      gap: 60px;
      max-width: 1100px;
      margin: 0 auto;
      align-items: auto;
  }

  /* 왼쪽 (스티키) */
  .left {
      flex: 1;
      position: sticky;
      top: 100px;
      /* 메뉴바 높이에 맞춰 조정 */
      align-self: flex-start;
  }

  h2 {
      font-size: 36px;
      font-weight: 900;
      margin-bottom: 20px;
  }

  .intro {
      font-size: 18px;
      font-weight: 600;
      line-height: 1.8;
  }

  :root {
      --left-width: 360px;
      --dot-col: 30px;
      --dot-size: 12px;
      --line-width: 2px;
      --accent: #0a4bff;
  }

  /* 2025.10.15 class 변경 */
  /* 오른쪽 연혁 */
  .history-right {
      flex: 1;
      position: relative;
  }

  /* 2026.02.12 class 변경 */
  .timeline-grid {
      margin-top: 20px;
      /* 세로선 기준 */
  }

  /* 세로 라인 */
  .timeline-grid {
      position: relative;
      margin-top: 20px;
  }

  .timeline-item::before {
      content: "";
      position: absolute;
      left: calc((var(--dot-col) / 2) - (var(--line-width) / 2));
      top: calc(var(--dot-size) / 2 + 4px);
      bottom: -48px;
      /* margin-bottom 만큼 */
      width: var(--line-width);
      background: #e6e6e6;
  }

  /* 각 아이템: 왼쪽(dot) / 오른쪽(text) 그리드 */
  .timeline-item {
      position: relative;
      display: grid;
      grid-template-columns: var(--dot-col) 1fr;
      gap: 20px;
      align-items: start;
      margin-bottom: 36px;
  }

  /* 도트(왼쪽 칸 가운데 정렬) */
  .timeline-item .dot {
      width: var(--dot-size);
      height: var(--dot-size);
      border-radius: 50%;
      background: var(--accent);
      border: 3px solid #fff;
      box-shadow: 0 0 0 2px rgba(10, 75, 255, 0.12);
      justify-self: center;
      margin-top: 4px;
      z-index: 1;
  }

  /* 날짜 / 텍스트 */
  .timeline-date {
      font-weight: 700;
      color: var(--accent);
      margin-bottom: 6px;
      font-size: 15px;
  }

  .timeline-text {
      font-size: 14.5px;
      color: #333;
      line-height: 1.7;
      margin: 0;
  }

  .timeline-item:last-child::before {
      display: none;
  }

  /* 2026.02.12 class 추가 */
  .year-tabs {
      display: flex;
      gap: 20px;
      margin-bottom: 30px;
  }

  /* 2026.02.12 class 추가 */
  .year-tab {
      padding: 14px 0;
      cursor: pointer;
      font-size: 20px;
      color: #777;
      position: relative;
      border-bottom: 1px solid #ddd;
      transition: 0.2s;
      text-align: center;
      white-space: nowrap;
  }

  /* 2026.02.12 class 추가 */
  .year-tab.active {
      color: #001B8B;
      font-weight: 700;
  }

  /* 2026.02.12 class 추가 */
  .year-tab:hover {
      color: #000;
  }

  /* 2026.02.12 class 추가 */
  .year-tab.active::after {
      content: "";
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 3px;
      background: #001B8B;
  }

  /* 2025.10.15 반응형 수정 */
  @media (max-width:900px) {
      .section-container {
          gap: 30px;
      }

      .left {
          width: 260px;
          top: 80px;
      }

      :root {
          --left-width: 260px;
      }
  }

  @media (max-width:640px) {

      /* 모바일: 좌/우 수직배치 */
      .history-container {
          flex-direction: column;
      }

      .left {
          position: static;
          width: 100%;
          margin-bottom: 24px;
      }

      .timeline-grid::before {
          left: calc(var(--dot-col) / 2);
      }
  }`, "",{"version":3,"sources":["webpack://./static/css/history.css"],"names":[],"mappings":"EAAE,UAAU;EACV;MACI,aAAa;EACjB;;EAEA,wBAAwB;EACxB;MACI,aAAa;MACb,SAAS;MACT,iBAAiB;MACjB,cAAc;MACd,iBAAiB;EACrB;;EAEA,aAAa;EACb;MACI,OAAO;MACP,gBAAgB;MAChB,UAAU;MACV,kBAAkB;MAClB,sBAAsB;EAC1B;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,mBAAmB;EACvB;;EAEA;MACI,eAAe;MACf,gBAAgB;MAChB,gBAAgB;EACpB;;EAEA;MACI,mBAAmB;MACnB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,iBAAiB;EACrB;;EAEA,wBAAwB;EACxB,WAAW;EACX;MACI,OAAO;MACP,kBAAkB;EACtB;;EAEA,wBAAwB;EACxB;MACI,gBAAgB;MAChB,WAAW;EACf;;EAEA,UAAU;EACV;MACI,kBAAkB;MAClB,gBAAgB;EACpB;;EAEA;MACI,WAAW;MACX,kBAAkB;MAClB,0DAA0D;MAC1D,oCAAoC;MACpC,aAAa;MACb,qBAAqB;MACrB,wBAAwB;MACxB,mBAAmB;EACvB;;EAEA,mCAAmC;EACnC;MACI,kBAAkB;MAClB,aAAa;MACb,yCAAyC;MACzC,SAAS;MACT,kBAAkB;MAClB,mBAAmB;EACvB;;EAEA,oBAAoB;EACpB;MACI,sBAAsB;MACtB,uBAAuB;MACvB,kBAAkB;MAClB,yBAAyB;MACzB,sBAAsB;MACtB,6CAA6C;MAC7C,oBAAoB;MACpB,eAAe;MACf,UAAU;EACd;;EAEA,aAAa;EACb;MACI,gBAAgB;MAChB,oBAAoB;MACpB,kBAAkB;MAClB,eAAe;EACnB;;EAEA;MACI,iBAAiB;MACjB,WAAW;MACX,gBAAgB;MAChB,SAAS;EACb;;EAEA;MACI,aAAa;EACjB;;EAEA,wBAAwB;EACxB;MACI,aAAa;MACb,SAAS;MACT,mBAAmB;EACvB;;EAEA,wBAAwB;EACxB;MACI,eAAe;MACf,eAAe;MACf,eAAe;MACf,WAAW;MACX,kBAAkB;MAClB,6BAA6B;MAC7B,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;EACvB;;EAEA,wBAAwB;EACxB;MACI,cAAc;MACd,gBAAgB;EACpB;;EAEA,wBAAwB;EACxB;MACI,WAAW;EACf;;EAEA,wBAAwB;EACxB;MACI,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,OAAO;MACP,WAAW;MACX,WAAW;MACX,mBAAmB;EACvB;;EAEA,sBAAsB;EACtB;MACI;UACI,SAAS;MACb;;MAEA;UACI,YAAY;UACZ,SAAS;MACb;;MAEA;UACI,mBAAmB;MACvB;EACJ;;EAEA;;MAEI,kBAAkB;MAClB;UACI,sBAAsB;MAC1B;;MAEA;UACI,gBAAgB;UAChB,WAAW;UACX,mBAAmB;MACvB;;MAEA;UACI,8BAA8B;MAClC;EACJ","sourcesContent":["  /* 본문 섹션 */\n  .history-section {\n      padding: 60px;\n  }\n\n  /* 2026.02.12 class 변경 */\n  .history-container {\n      display: flex;\n      gap: 60px;\n      max-width: 1100px;\n      margin: 0 auto;\n      align-items: auto;\n  }\n\n  /* 왼쪽 (스티키) */\n  .left {\n      flex: 1;\n      position: sticky;\n      top: 100px;\n      /* 메뉴바 높이에 맞춰 조정 */\n      align-self: flex-start;\n  }\n\n  h2 {\n      font-size: 36px;\n      font-weight: 900;\n      margin-bottom: 20px;\n  }\n\n  .intro {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 1.8;\n  }\n\n  :root {\n      --left-width: 360px;\n      --dot-col: 30px;\n      --dot-size: 12px;\n      --line-width: 2px;\n      --accent: #0a4bff;\n  }\n\n  /* 2025.10.15 class 변경 */\n  /* 오른쪽 연혁 */\n  .history-right {\n      flex: 1;\n      position: relative;\n  }\n\n  /* 2026.02.12 class 변경 */\n  .timeline-grid {\n      margin-top: 20px;\n      /* 세로선 기준 */\n  }\n\n  /* 세로 라인 */\n  .timeline-grid {\n      position: relative;\n      margin-top: 20px;\n  }\n\n  .timeline-item::before {\n      content: \"\";\n      position: absolute;\n      left: calc((var(--dot-col) / 2) - (var(--line-width) / 2));\n      top: calc(var(--dot-size) / 2 + 4px);\n      bottom: -48px;\n      /* margin-bottom 만큼 */\n      width: var(--line-width);\n      background: #e6e6e6;\n  }\n\n  /* 각 아이템: 왼쪽(dot) / 오른쪽(text) 그리드 */\n  .timeline-item {\n      position: relative;\n      display: grid;\n      grid-template-columns: var(--dot-col) 1fr;\n      gap: 20px;\n      align-items: start;\n      margin-bottom: 36px;\n  }\n\n  /* 도트(왼쪽 칸 가운데 정렬) */\n  .timeline-item .dot {\n      width: var(--dot-size);\n      height: var(--dot-size);\n      border-radius: 50%;\n      background: var(--accent);\n      border: 3px solid #fff;\n      box-shadow: 0 0 0 2px rgba(10, 75, 255, 0.12);\n      justify-self: center;\n      margin-top: 4px;\n      z-index: 1;\n  }\n\n  /* 날짜 / 텍스트 */\n  .timeline-date {\n      font-weight: 700;\n      color: var(--accent);\n      margin-bottom: 6px;\n      font-size: 15px;\n  }\n\n  .timeline-text {\n      font-size: 14.5px;\n      color: #333;\n      line-height: 1.7;\n      margin: 0;\n  }\n\n  .timeline-item:last-child::before {\n      display: none;\n  }\n\n  /* 2026.02.12 class 추가 */\n  .year-tabs {\n      display: flex;\n      gap: 20px;\n      margin-bottom: 30px;\n  }\n\n  /* 2026.02.12 class 추가 */\n  .year-tab {\n      padding: 14px 0;\n      cursor: pointer;\n      font-size: 20px;\n      color: #777;\n      position: relative;\n      border-bottom: 1px solid #ddd;\n      transition: 0.2s;\n      text-align: center;\n      white-space: nowrap;\n  }\n\n  /* 2026.02.12 class 추가 */\n  .year-tab.active {\n      color: #001B8B;\n      font-weight: 700;\n  }\n\n  /* 2026.02.12 class 추가 */\n  .year-tab:hover {\n      color: #000;\n  }\n\n  /* 2026.02.12 class 추가 */\n  .year-tab.active::after {\n      content: \"\";\n      position: absolute;\n      bottom: -1px;\n      left: 0;\n      width: 100%;\n      height: 3px;\n      background: #001B8B;\n  }\n\n  /* 2025.10.15 반응형 수정 */\n  @media (max-width:900px) {\n      .section-container {\n          gap: 30px;\n      }\n\n      .left {\n          width: 260px;\n          top: 80px;\n      }\n\n      :root {\n          --left-width: 260px;\n      }\n  }\n\n  @media (max-width:640px) {\n\n      /* 모바일: 좌/우 수직배치 */\n      .history-container {\n          flex-direction: column;\n      }\n\n      .left {\n          position: static;\n          width: 100%;\n          margin-bottom: 24px;\n      }\n\n      .timeline-grid::before {\n          left: calc(var(--dot-col) / 2);\n      }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
